import * as types from 'actions/modal/types';

const initialState = {
  modalType: null,
  modalProps: {},
};

export default (state = initialState, action) => {
  switch (action.type) {
    case types.SHOW:
      return {
        modalType: action.modalType,
        modalProps: action.modalProps,
      };
    case types.HIDE:
      return initialState;
    default:
      return state;
  }
};
